import { render, staticRenderFns } from "./ConsultaColabEmpresa.vue?vue&type=template&id=4febc04f&scoped=true&"
import script from "./ConsultaColabEmpresa.vue?vue&type=script&lang=js&"
export * from "./ConsultaColabEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaColabEmpresa.vue?vue&type=style&index=0&id=4febc04f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4febc04f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
